<template>
  <v-content>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <!-- 屏蔽 footer -->
    <!-- <core-footer v-if="$route.name !== 'Maps'" /> -->
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: '系统知识分享'
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
